import { registerPlugin } from '@capacitor/core';
const CapPython = registerPlugin('CapPython', {
    web: () => import('./web').then(m => new m.CapPythonWeb()),
});
export * from './definitions';
export { CapPython };
//# sourceMappingURL=index.js.map